var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 201 c-32 -28 -33 -32 -33 -108 l0 -79 79 1 c75 0 79 2 107 33 43 47 41 102 -5 148 -46 46 -101 48 -148 5z m137 -16 c18 -17 25 -35 25 -62 -1 -67 -44 -99 -120 -88 -46 6 -48 8 -54 43 -10 62 -7 78 20 106 36 35 95 36 129 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 157 c-6 -15 16 -53 43 -74 32 -25 87 -9 56 16 -10 8 -16 9 -21 1 -11 -17 -43 8 -47 37 -3 29 -23 42 -31 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.eb46d263ab91f1242cb74ad50ea4acf1.svg";
export { ForwardRef as ReactComponent };